import image3 from "../../assets/images/image3.jpg";
import image6 from "../../assets/images/image6.jpg";
import image17 from "../../assets/images/image17.jpg";
import image19 from "../../assets/images/image19.jpg";

export const slidesData = [
  {
    title: "RIGOUR",
    description:
      "We do things properly. That means starting at the beginning, asking tricky questions and trusting the process, because we know it works. Our methods are based on years of training and industry experience.",
    imageURL: image3,
  },
  {
    title: "HONESTY",
    description:
      "We’ll be honest with you about your brand. Sometimes brutally so, because someone has to. And we ask the same of you. We need to know your real goals and motivations for this work.",
    imageURL: image6,
  },
  {
    title: "COLLABORATION",
    description:
      "This is your project and we’re here to facilitate. We’ll challenge and inspire your thinking, and ultimately find the answers together. We specialise in working with teams and we need you to be involved",
    imageURL: image17,
  },
  {
    title: "CREATIVITY",
    description:
      "When strategy meets playful thinking, things get interesting. Far from being dry reseachers, we're more about big ideas. We bring fresh perspectives and directions you may not have bargained for.",
    imageURL: image19,
  },
];
